module.exports = __webpack_public_path__ + "img/login-v2.79eb5bed.svg";